{
	"backLinkTitle": "Înapoi la gestionarea declarațiilor"
}
